export const campaignReviewDataValidator = values => {
  const errors: Record<string, any> = {}

  if (new Date(values.startDate) > new Date(values.endDate)) {
    errors.endDate = 'End date must be greater than start date'
  }

  if (values.goalRtbImpressions < values.goalImpressions) {
    errors.goalRtbImpressions = 'Goal RTB impressions must be greater or equal than goal impressions' // eslint-disable-line
  }

  if (!values.cpm) errors.cpm = 'CPM is required'

  if (!values.goalImpressions) errors.goalImpressions = 'Goal impressions is required'

  if (!values.goalRtbImpressions) errors.goalRtbImpressions = 'Goal RTB impressions is required'

  if (!values.region) errors.region = 'Region is required'

  return errors
}
